import { ForecastDataCalculation } from '@portal/common/types';

export const getNowcastsStartYear = (
    forecastDataCalculationMap: ForecastDataCalculation | null
): number | null => {
    if (!forecastDataCalculationMap) {
        return null;
    }
    return forecastDataCalculationMap.start_year + 1;
};

export const calculateNowcastYears = (
    forecastDataCalculationMap: ForecastDataCalculation | null,
    forecastDataCalculationYears?: number | null,
    lastPublishedYear?: number | null
): number[] | null => {
    if (!forecastDataCalculationMap) {
        return null;
    }

    const startYear = getNowcastsStartYear(forecastDataCalculationMap);
    if (startYear === null) {
        return null;
    }

    const { start_year: datasetStartYear } = forecastDataCalculationMap;
    const years = forecastDataCalculationYears || forecastDataCalculationMap.years;

    const endYear = Math.min(lastPublishedYear ?? datasetStartYear, datasetStartYear) + years;

    return Array.from({ length: Math.max(endYear - startYear + 1, 0) }, (_, i) => startYear + i);
};
